<template>
  <div class="backdrop">
    <div class="popup">
      <i class="bi bi-x" @click="close"></i>
      <div class="content">
        <div class="title">{{ content.nome }}</div>

        <div class="data">
          [{{ content.data }}]
          <img width="15px" src="@/assets/images/cruz.png" />
          <button
            v-if="audioAtual && isPlayingAtual"
            class="button-audio"
            @click="stopAllPessoas()"
          >
            <i class="bi bi-stop-circle"></i> Ouça o relato
          </button>
          <button
            v-else
            class="button-audio"
            @click="playAudioPessoa(content.audio)"
          >
            <i class="bi bi-play-circle"></i> Ouça o relato
          </button>
        </div>
        <div class="alterado">
          <!-- <i>*Os nomes das vítimas foram alterados.</i> -->
        </div>
        <div class="btn-content">
          <div
            class="button btn-biografia"
            @click="openBiografia"
            :class="{ selected: isBiografia }"
          >
            relato
          </div>
          <div
            class="button btn-linha-tempo"
            @click="closeBiografia"
            :class="{ selected: !isBiografia }"
          >
            linha do tempo
          </div>
        </div>
        <div class="conteudo">
          <transition name="slide">
            <div
              v-if="isBiografia"
              class="conteudo-biografia"
              v-html="content.biografia"
            ></div>
          </transition>
          <div
            v-if="!isBiografia"
            class="conteudo-linha-tempo"
            v-html="content.linhaTempo"
          ></div>
        </div>

        <div class="btn-controls">
          <div class="button" @click="anterior">
            anterior <i class="icon-l bi bi-arrow-left"></i>
          </div>
          <div class="button" @click="proximo">
            <i class="icon-r bi bi-arrow-right"></i>proximo
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dominos } from "@/consts/domino.js";
import { scaleOut, scaleIn } from "@/assets/animate";
import audios from "@/mixins/audios.js";

export default {
  name: "PopUpCinza",
  props: {
    title: {
      type: String,
      default: "ESTE SITE UTILIZA COOKIES",
    },
    index: {
      type: Number,
      default: 0,
    },
    isShowed: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mixins: [audios],
  watch: {
    isShowed(val, old) {
      if (!old && val) {
        this.showed = true;
        this.showAnimation();
      } else if (old && !val) {
        this.showed = false;
      }
    },
  },
  data() {
    return {
      showed: false,
      dominos,
      i: 0,
      isBiografia: true,
    };
  },
  computed: {
    content() {
      return this.dominos[this.i];
    },
    soundState() {
      return this.$store.state.soundState;
    },
    audioAtual() {
      switch (this.content.audio) {
        case "adelson":
          return this.audioAdelson;
        case "aldaberto":
          return this.audioAldaberto;
        case "aldemir":
          return this.audioAldemir;
        case "genivaldo":
          return this.audioGenivaldo;
        case "jose":
          return this.audioJose;
        case "jane":
          return this.audioJane;
        case "roberio":
          return this.audioRoberio;
        default:
          return false;
      }
    },
    isPlayingAtual() {
      switch (this.content.audio) {
        case "adelson":
          return this.audioAdelsonPlaying;
        case "aldaberto":
          return this.audioAldabertoPlaying;
        case "aldemir":
          return this.audioAldemirPlaying;
        case "genivaldo":
          return this.audioGenivaldoPlaying;
        case "jose":
          return this.audioJosePlaying;
        case "jane":
          return this.audioJanePlaying;
        case "roberio":
          return this.audioRoberioPlaying;
        default:
          return false;
      }
    },
  },
  mounted() {
    if (this.isShowed) this.showed = true;
    this.i = this.index;
    this.showAnimation();
    document.body.style.overflowY = "hidden";
  },
  beforeDestroy() {
    scaleOut(this.$el);
    document.body.style.overflowY = "scroll";
    this.stopAllPessoas();
  },
  methods: {
    close() {
      this.$emit("close");
    },

    showAnimation() {
      scaleIn(this.$el.lastChild);
    },
    openBiografia() {
      this.isBiografia = true;
    },
    closeBiografia() {
      this.isBiografia = false;
    },
    anterior() {
      if (this.i === 0) return;
      this.stopAllPessoas();
      this.i--;
    },
    proximo() {
      if (this.i === this.dominos.length - 1) return;
      this.stopAllPessoas();
      this.i++;
    },
  },
};
</script>


<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.button-audio {
  margin-left: 15px;
  display: inline;
  font-size: 0.8rem;
}

.alterado {
  font-size: 0.8em;
  color: #999;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(10px);
  opacity: 0;
  transition: all 150ms ease-in 0s;
}
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffffc0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;

  .popup {
    width: 100%;
    min-height: 100%;
    max-height: 100%;
    height: fit-content;
    position: relative;
    background-color: white;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    overflow-y: auto;
  }

  .content {
    width: 700px;
    padding: 20px 0px 0px 0px;
    max-height: 100%;
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-direction: column;

    .title {
      font-size: 2.3rem;
      font-weight: 300;
      text-transform: uppercase;
    }

    .data {
      font-size: 1.3rem;
      font-family: Roboto Mono;
      font-weight: 300;
      margin-bottom: 15px;
    }

    .btn-content {
      display: flex;
      column-gap: 20px;
      margin: 10px 0px;

      .button {
        border: 1px solid #62626280;
        padding: 1px 20px;
        border-radius: 7px;
        cursor: pointer;

        &.selected {
          background-color: #626262;
          color: white;
        }
      }
    }

    .btn-controls {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      user-select: none;

      .button {
        border: 1px solid #62626280;
        padding: 1px 20px;
        border-radius: 7px;
        cursor: pointer;

        .icon-l {
          margin-left: 10px;
        }

        .icon-r {
          margin-right: 10px;
        }
      }
    }

    .conteudo {
      max-height: 250px;
      overflow-y: scroll;
      padding-bottom: 50px;
      margin: 15px 0px;
      padding-right: 30px;

      /deep/ b {
        color: #d01c1f;
      }

      /deep/ span {
        font-weight: bold;
      }

      /deep/ blockquote {
        margin-left: 30px;
        font-style: italic;
      }
    }
  }

  .bi-x {
    font-size: 2.5rem;
    color: #626262;
    position: absolute;
    top: 20px;
    left: 15px;
    cursor: pointer;
  }
}

*::-webkit-scrollbar {
  width: 8px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
  border-radius: 8px;
}

*::-webkit-scrollbar-thumb {
  background: rgb(185, 185, 185);
  border-radius: 8px;
}

@media screen and (max-width: 480px) {
  .backdrop {
    .popup {
      top: 0;
      left: 0;
      position: fixed;
      width: 100%;
      min-height: 100vh;
      max-width: 100vw;
    }

    .content {
      max-width: 100vw;
      padding: 80px 30px;
      padding-bottom: 20px;

      .conteudo {
        max-height: 50vh;
      }
    }
  }

  .button-audio {
    margin-left: 0px;
    margin-top: 10px;
  }

  *::-webkit-scrollbar {
    width: 4px;
    height: 12px;
  }

  *::-webkit-scrollbar-track {
    background: #e4e4e4;
    border-radius: 8px;
  }

  *::-webkit-scrollbar-thumb {
    background: rgb(185, 185, 185);
    border-radius: 8px;
  }
}
</style>
